import { render } from "./SectionNineteen.vue?vue&type=template&id=021047da&scoped=true"
import script from "./SectionNineteen.vue?vue&type=script&lang=js"
export * from "./SectionNineteen.vue?vue&type=script&lang=js"

import "./SectionNineteen.vue?vue&type=style&index=0&id=021047da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-021047da"]])

export default __exports__